import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMsanColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 448 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 32,
			width: 214.5,
			height: 214.5,
			fill: "#E35E30"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 233,
			y: 32,
			width: 214.5,
			height: 214.5,
			fill: "#8BB62D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 266,
			width: 214.5,
			height: 214.5,
			fill: "#40A3EB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 233,
			y: 266,
			width: 214.5,
			height: 214.5,
			fill: "#F7BB34"
		})
	]
});
export default SvgMsanColor;
